let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("adefN")).then(() => parcelRequire('8DuT4'));